import * as Widgets from '@mm/constants/widgets';
import { WidgetTypes } from '@mm/state/model/WidgetModel';

export const VALID_START_BOT_WIDGET_TYPES = [
  Widgets.QUICK_QUESTION,
  Widgets.IMAGE,
  Widgets.TEXT,
  Widgets.FORM,
  Widgets.EMAIL,
  Widgets.ATTACHMENT,
  Widgets.AUDIO,
  Widgets.GIF,
  Widgets.DELAY,
  Widgets.NAVIGATE,
  Widgets.TYPING,
  Widgets.TAGS,
  Widgets.VIDEO,
  WidgetTypes.OTN,
  WidgetTypes.SMS_OPT_IN,
  WidgetTypes.SMS_OPT_IN_V2,
  WidgetTypes.SMS_OPT_IN_REPLY,
  WidgetTypes.SEND_DATA,
  WidgetTypes.OPT_IN,
  WidgetTypes.ATTRIBUTE,
  WidgetTypes.GALLERY,
];
